const state = {
    renewPopShow: true,
    // 激活码结果
    activationCodeList: [],
    // 激活码
    isActivationCode: [],
    // 所有云手机
    globalInstanceList: [],
    // 续费数组
    renewList: [],
    localShotinfoList: []
}
const mutations = {
    SET_RENEWPOPSHOW: (state, Bln) => {
        state.renewPopShow = Bln
    },
    SET_ACTIVATIONCODELIST: (state, cover) => {
        state.activationCodeList = cover
    },
    SET_ISACTIVATIONCODE: (state, cover) => {
        state.isActivationCode = cover
    },
    SET_GLOBALINSTANCELIST: (state, cover) => {
        state.globalInstanceList = cover
    },
    SET_RENEWLIST: (state, cover) => {
        state.renewList = cover
    },
    SET_LOCALSHOTINFOLIST: (state, list) => {
        state.localShotinfoList = list
    },
}
export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}